const config = {
  apiUrl: process.env.REACT_APP_API_URL || '/api',
};

export default config;
